<template>
  <div>
    <div class="guaitopbg">
      <div class="guai-recharge">
        <div class="recharge-right">
          <div class="recharge-box">
            <img class="recharge-icon" src="/static/index_jifen.png" />
            <div class="recharge-num">{{ amount }}</div>
          </div>
          <div class="recharge-box">
            <img class="recharge-icon" src="/static/index_kaquan.png" />
            <div class="recharge-num">{{ userinfo.package_account }}</div>
          </div>
          <div class="recharge-botton" @click="toAccount()">充值</div>
        </div>
      </div>
      <div class="banner-box">
        <van-swipe
          class="my-swipe"
          :show-indicators="false"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item v-for="(img, index) in banners" :key="img.id">
            <img :src="img.image" class="swipeImg" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="offline-menu-list">
        <div
          class="offline-menu-box"
          v-for="(item, index) in offlinemeun"
          @click="
            toServiceList(
              item.product_id ? item.product_id : '1',
              item.event,
              item.url ? item.url : ''
            )
          "
        >
          <img :src="item.image" class="offline-menu-icon" />
          <div class="offline-menu-name">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <img
      src="/static/chejian.png"
      class="mot-img"
      @click="toyearInspectionType()"
    />
    <div class="online-recharge">
      <img
        src="/static/index_youkachongzhi.png"
        @click="toOilCard()"
        class="online-rechargeimg"
      />
      <img
        src="/static/index_huafeichongzhi.png"
        @click="tophone()"
        class="online-rechargeimg"
      />
    </div>
    <div class="online-bottom">
      <div class="online-menu">
        <div
          class="online-menu-box"
          v-for="(item, index) in onlinemenu"
          @click="tocommon(item.event, item.cate_id)"
        >
          <img :src="item.image" class="online-menu-icon" />
          <div class="online-menu-name">{{ item.name }}</div>
        </div>
      </div>
      <div class="recharge-menu">
        <img
          src="/static/index_chuxingfuwu.png"
          @click="tochuxing()"
          class="recharge-menuimg"
        />
        <img
          src="/static/index_jifenzhuanrang.png"
          @click="totixian()"
          class="recharge-menuimg"
        />
      </div>
    </div>
    <div class="indexnone"></div>
    <taber></taber>
  </div>
</template>

<script>
import taber from "@/components/taber/taber";
import httper from "../api/http";
import { Dialog } from "vant";
// let geolocation;
export default {
  components: {
    taber
  },
  data() {
    return {
      bianjie: [
        "/static/meishi.png",
        "/static/meishi.png",
        "/static/meishi.png",
        "/static/meishi.png",
        "/static/meishi.png",
        "/static/meishi.png"
      ],
      fuwu: [],
      tabs: [
        {
          name: "线下服务",
          check: true
        },
        {
          name: "线上服务",
          check: false
        }
      ],
      offlinemeun: [
        {
          image: require("../../static/index_anquanjian.png"),
          event: "toServiceList",
          name: "安全检测",
          product_id: "91"
        },
        {
          image: require("../../static/index_xiche.png"),
          event: "toServiceList",
          name: "洗车",
          product_id: "1"
        },
        {
          image: require("../../static/index_cheneixiaodu.png"),
          event: "toServiceList",
          name: "车内消毒",
          product_id: "92"
        },
        {
          image: require("../../static/index_jiyoubaoyang.png"),
          event: "toServiceList",
          name: "机油保养",
          product_id: "6"
        },
        {
          image: require("../../static/index_biaozhundala.png"),
          event: "toServiceList",
          name: "标准打蜡",
          product_id: "3"
        },
        {
          image: require("../../static/index_huahenbuqi.png"),
          event: "toServiceList",
          name: "划痕补漆",
          product_id: "8"
        },
        {
          image: require("../../static/index_kongtiaoqingxi.png"),
          event: "toServiceList",
          name: "空调清洗",
          product_id: "93"
        },
        {
          image: require("../../static/index_butai.png"),
          event: "toServiceList",
          name: "补胎",
          product_id: "94"
        },
        {
          image: require("../../static/index_cheliangnianjian.png"),
          event: "carAnnualReview",
          name: "车辆年检",
          product_id: ""
        },
        {
          image: require("../../static/index_nuochefuwu.png"),
          event: "toMoveCar",
          name: "挪车服务",
          product_id: ""
        },
        {
          image: require("../../static/index_daolujiuyuan.png"),
          event: "roadRescue",
          name: "道路救援",
          product_id: ""
        },
        {
          image: require("../../static/index_daijiafuwu.png"),
          event: "tochuxing",
          name: "代驾服务",
          product_id: ""
        }
      ],
      onlinemenu: [
        {
          event: "toshoppingList",
          image: require("../../static/index_yulehuiyuan.png"),
          name: "娱乐会员",
          cate_id: "1"
        },
        {
          event: "toshoppingList",
          image: require("../../static/index_appgouwuka.png"),
          name: "APP购物卡",
          cate_id: "4"
        },
        {
          event: "toshoppingList",
          image: require("../../static/index_chaoshigouwu.png"),
          name: "超市购物券",
          cate_id: "2"
        },
        {
          event: "toshoppingList",
          image: require("../../static/index_shenghuofuwu.png"),
          name: "生活服务",
          cate_id: "8"
        },
        {
          event: "toshoppingList",
          image: require("../../static/index_meishiquan.png"),
          name: "美食券",
          cate_id: "3"
        }
      ],
      tabsIndex: 0,
      serviceList: [], // 首页服务
      serviceList1: [],
      phoneNum: "", //用户手机号
      amount: "", //用户账户余额
      userinfo: "", //用户信息
      phoneNumber: "",
      banners: [],
      banner1: [
        {
          image: "/static/banner1.png"
        },
        {
          image: "/static/icon/BANNER.png"
        }
      ],
      latitude: "", //纬度
      longitude: "", //经度
      city: "", //城市
      coupon: "", //车辆送检信息
      page_size: 20, // 列表每页条数,默认为20
      storePage: 1, // 服务商家列表当前页数,默认为1
      storeList: "",
      loads: 0,
      storeFlag: false,
      cityStatus: false, // 用户是否手动选择市区,默认为false
      cityList: [
        "广州市",
        "韶关市",
        "深圳市",
        "珠海市",
        "汕头市",
        "佛山市",
        "江门市",
        "湛江市",
        "茂名市",
        "肇庆市",
        "惠州市",
        "梅州市",
        "汕尾市",
        "河源市",
        "阳江市",
        "清远市",
        "东莞市",
        "中山市",
        "潮州市",
        "揭阳市",
        "云浮市"
      ], // 接口获取市区列表
      isMaskHidden: true, // 是否隐藏遮盖层,默认为true
      buttonClicked: false, // 防止用户重复点击
      projectList: [],
      productList: [],
      canWithdraw: true,
      availableUser: false,
      indexMenus: {},
      offline: [],
      annual: [],
      ease: [],
      common: [],
      showMenus: true,
      changeTitle: "",
      unavailableRecharge: true, //话费不可用
      show: true, //是否显示弹窗
      showtip: false, //到期商户
      filemesg: "",
      is_stop_mobile_oil: false,
      stop_mobile_oil_time: "",
      showjihuo: false, //激活弹出海报
      usertype: "0",
      cardstatus: false //车主卡是否激活
    };
  },
  created() {
    let source = this.getParameterByName("source");
    // if ((!!source && source!='undefined')) {
    //   sessionStorage.setItem("source", source)
    //   this.request('getphoneNumber', {
    //     source: source
    //   })
    // }

    // var userId = [42,45,46,49,50]
    // var availableUser = true

    // for (var i = 0; i < userId.length; i++) {
    //     if (userId[i] == that.userinfo.id) {
    //       availableUser = false
    //     }
    //   }
    // if (that.tabsindex === 2 && availableUser) {
    //   Dialog.alert({
    //     title: '提示',
    //     message: '此功能暂未开放!',
    //   }).then(() => {
    //     that.tabsindex = 0
    //     that.tabs[2].select = false
    //     that.tabs[0].select = true
    //   });
    // }
    console.log("source", source);
    this.request("sysconfig");
    if (!!source && source !== "undefined") {
      if (source !== sessionStorage.getItem("source")) {
        sessionStorage.removeItem("source");
        sessionStorage.setItem("source", source);
      } else {
        sessionStorage.setItem("source", source);
      }
      this.request("getphoneNumber", {
        source: source
      });
    } else {
      sessionStorage.setItem("source", "llcf");
    }
    this.request("indexMenus", {
      source: source
    });
    this.request("getBanners", {
      source: source
    });
    this.request("getagent", {
      source: source
    });
    this.request("getUserInfo");
    this.request("getproductList", {
      page: 1,
      page_size: 6
    });
    this.request("getService");
    this.request("getvehicle");
    this.unavailableRecharge =
      sessionStorage.getItem("source") === "sjcmdl" ||
      sessionStorage.getItem("source") == "cxkjdl";
    if (sessionStorage.getItem("show") === "false") {
      this.show = sessionStorage.getItem("show") !== "false";
    } else {
      this.show = true;
    }
  },
  mounted() {},
  methods: {
    close() {
      this.show = false;
      this.show = sessionStorage.setItem("show", this.show);
    },
    closejihuo() {
      this.showjihuo = false;
    },
    tovipcard() {
      this.$router.push({
        path: "/vipCard"
      });
    },
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true;
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            this.buttonClicked = false;
          }, duration);
        }
        resolve(true);
      });
    },
    //改变tabs
    changetabs(e) {
      this.tabs.map((item, index) => (item.check = index === Number(e)));
      this.tabsIndex = Number(e);
      if (this.tabsIndex === 0) {
        this.request("getService");
      }
    },
    tap(e) {
      // e.stopPropagation();
      this.city = e.target.dataset.city;
      sessionStorage.setItem("city", e.target.dataset.city);
      this.getaddress();
      this.storePage = 1;
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.city = this.city;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.request("getStoreList", requestData);
    },
    // 展示/隐藏遮盖层
    showMask1() {
      this.isMaskHidden = !this.isMaskHidden;
      if (this.isMaskHidden) {
        // this.showMask.call(that, true, -300);
      } else {
        // this.showMask.call(that, false, -300);
      }
    },
    // 改变市区
    changeCity(city) {
      let that = this;
      let requestData = {};
      that.city = city;
      that.storeList = [];
      that.storePage = 1;
      that.storeFlag = true;
      that.cityStatus = true;

      requestData.product_id = that.product_id;
      requestData.city = city;
      requestData.page = 1;
      requestData.page_size = that.page_size;
      that.request("getStoreList", requestData);
      if (this.isMaskHidden) {
        this.showMask.call(that, true, -300);
      } else {
        this.showMask.call(that, false, -300);
      }
    },
    //获取附近门店
    getserviceList(title, name) {
      let that = this;
      let product_id = that.fuwu[title].product_id;
      let requestData = {};
      requestData.product_id = product_id;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.request("getStoreList", requestData);
    },
    toease(event) {
      let that = this;
      switch (event) {
        case "toOilCard":
          if (this.is_stop_mobile_oil) {
            this.$toast({
              message: this.stop_mobile_oil_time + "充值通道维护中~"
            });
            return;
          } else {
            this.$router.push({
              path: "/oilCard"
            });
          }
          break;
        case "tophone":
          if (that.unavailableRecharge) {
            this.$toast({
              message: "手机充值功能维护中，敬请期待~"
            });
          } else {
            if (this.is_stop_mobile_oil) {
              this.$toast({
                message: this.stop_mobile_oil_time + "充值通道维护中~"
              });
              return;
            } else {
              this.$router.push({
                path: "/phone"
              });
            }
          }
          break;
        case "tovideoList":
          this.$router.push({
            path: "/videoDetail",
            query: {
              cate_id: 1
            }
          });
          // this.$router.push({
          //   // path: "/shoppingDetail",
          //   path: "/shoppingDetail",
          //   query: {
          //     cate_id: 1
          //   }
          // })
          break;
        case "toAPPshoppingList":
          this.$router.push({
            path: "/AppShop",
            query: {
              cate_id: 4
            }
          });
          // this.$router.push({
          //   // path: "/shoppingDetail",
          //   path: "/shoppingDetail",
          //   query: {
          //     cate_id: 4
          //   }
          // })
          break;
      }
    },
    toSellingCard() {
      this.$router.push({
        path: "/sellingCards"
      });
    },
    tochuxing() {
      this.$router.push({
        path: "/shoppingDetail",
        query: {
          cate_id: "5"
        }
      });
    },
    tocommon(event, cate_id) {
      switch (event) {
        case "toshoppingList":
          this.$router.push({
            // path: "/shoppingDetail",
            path: "/shoppingDetail",
            query: {
              cate_id: cate_id
            }
          });
          break;

        case "toJDE":
          this.$router.push({
            path: "/jingdongRecharge",
            //path: "/rechargeJD",
            query: {
              cate_id: "2"
            }
          });
          break;
        case "toTLD":
          this.$router.push({
            // path: "/shoppingDetail",
            path: "/charge",
            query: {
              cate_id: "4"
            }
          });
          break;
        case "redPack":
          this.$router.push({
            // path: "/shoppingDetail",
            path: "/alipay",
            query: {
              cate_id: "4"
            }
          });
          break;
      }
    },
    //跳转绑定手机号jiemian
    toChangePhone() {
      this.$router.push({
        path: "/changePhoneNum"
      });
    },
    //跳转账户充值
    toAccount() {
      this.$router.push({
        path: "/account"
      });
    },
    //跳转交易明细
    tomingxi() {
      this.$router.push({
        path: "/jifenmingxi"
      });
    },
    //跳转账户充值界面
    toaccount() {
      this.$router.push({
        path: "/account"
      });
    },
    //跳转积分转让界面
    totixian() {
      this.$router.push({
        path: "/tixian"
      });
    },
    //跳转油卡充值界面
    toOilCard() {
      this.$router.push({
        path: "/oilCard"
      });
    },
    //跳转手机充值界面
    tophone() {
      this.$router.push({
        path: "/phone"
      });
    },
    //跳转音频会员界面
    tovideoList() {
      this.$router.push({
        path: "/videoDetail",
        query: {
          cate_id: 1
        }
      });
    },
    //跳转腾讯充值界面
    totengxunList() {
      this.$toast({
        message: "暂未开放"
      });
      // this.$router.push({
      //   path:"/tengxunList",
      // query: {
      //   cate_id: 7
      // }
      // })
    },
    //跳转超市购物券界面
    toshoppingList() {
      this.$router.push({
        // path: "/shoppingDetail",
        path: "/shoppingDetail",
        query: {
          cate_id: 2
        }
      });
    },
    //跳转APP购物卡界面
    toAPPshoppingList() {
      this.$router.push({
        path: "/AppShop",
        query: {
          cate_id: 4
        }
      });
    },
    //跳转美食券界面
    tofoodList() {
      this.$router.push({
        // path: "/foodList",
        path: "/shoppingDetail",
        query: {
          cate_id: 3
        }
      });
    },
    //跳转出行服务界面
    tochuxingList() {
      this.$router.push({
        // path: "/chuxingList",
        path: "/shoppingDetail",
        query: {
          cate_id: 5
        }
      });
    },
    //跳转游戏卡密界面
    togamesList() {
      this.$toast({
        message: "暂未开放"
      });
      // this.$router.push({
      //   path:"/gamesList",
      //   query: {
      //     cate_id: 6
      //   }
      // })
    },
    //跳转生活服务界面
    tolifeList() {
      this.$router.push({
        // path: "/lifeList",
        path: "/shoppingDetail",
        query: {
          cate_id: 8
        }
      });
    },
    //跳转商品列表
    toproductList() {
      let that = this;
      that.$router.push({
        path: "/productList"
      });
    },
    //跳转商品详情页
    toproDetail(index) {
      let that = this;
      that.$router.push({
        path: "/projectDetail",
        query: {
          id: index
        }
      });
    },
    //banner图跳转
    toDetail(url) {
      window.location.href = url;
      // this.$router.push({
      //   path:url
      // })
    },
    //跳转线下服务列表
    toServiceList(product_id, event, url) {
      if (event == "alert") {
        this.$toast({
          message: "暂未开放"
        });
        return;
      }
      if (event == "tochuxing") {
        this.$router.push({
          // path: "/chuxingList",
          path: "/shoppingDetail",
          query: {
            cate_id: "5"
          }
        });
        return;
      }
      if (event == "yuyuetip") {
        if (!!this.coupon) {
          this.$router.push({
            path: "/yuyuetip",
            query: {
              coupon: this.coupon
            }
          });
        } else {
          this.$toast({
            message: "暂无相关数据"
          });
        }
        return;
      }
      if (event == "toWeb") {
        if (url) {
          window.location.href = url;
        } else {
          this.$toast({
            message: "暂无相关数据"
          });
        }
        return;
      }
      if (event == "toMoveCar") {
        this.$router.push({
          path: "/moveCar"
        });
        return;
      }
      if (event == "roadRescue") {
        this.$router.push({
          path: "/roadRescue"
        });
        return;
      }
      if (event == "carAnnualReview") {
        // this.$router.push({
        //   path: '/yearlyInspection',
        //   query:{
        //     product_id: product_id
        //   }
        // })
        this.$router.push({
          path: "/yearInspectionType",
          query: {
            product_id: product_id
          }
        });
        return;
      }
      // if (event == 'toServiceList') {
      //   this.$router.push({
      //     path: '/serviceList',
      //     query: {
      //       product_id: product_id
      //     }
      //   })
      // }
      if (event == "toServiceList") {
        this.$router.push({
          path: "/offlineserverList",
          query: {
            product_id: product_id
          }
        });
      }
    },
    //年审banner图跳转年审页面
    toyearInspectionType() {
      this.$router.push({
        path: "/yearInspectionType"
      });
    },
    // 如果没有预约状态的服务编号,跳转服务商家详情页.反之跳转店铺详情
    toDesc(storeId) {
      let that = this;
      that.$router.push({
        path: "/serviceDesc",
        query: {
          id: storeId
        }
      });
    },
    getParameterByName(name) {
      name = name.replace(/\[/, "\\\[").replace(/]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.search);
      if (results == null) {
        return "";
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    },
    // 调用接口
    request(type = "", requestData = {}) {
      //根据source获取客服电话
      let that = this;
      switch (type) {
        // 获取菜单
        case "indexMenus":
          httper.get("index/menus", requestData, res => {
            if (res.code == 0) {
              this.indexMenus = res.data;
              this.offline = res.data.offline;
              this.annual = res.data.annual;
              this.ease = res.data.ease;
              this.common = res.data.common;
              this.showMenus = true;
            } else {
              this.showMenus = false;
            }
          });
          break;
        case "getBanners":
          httper.get("index/index-banner", requestData, res => {
            if (res.code == 0) {
              that.banners = res.data;
            }
          });
          break;
        // getagent
        case "getagent":
          httper.get("index/get-agent", requestData, res => {
            if (res.code == 0) {
              this.changeTitle = res.data.username || "优越服务";
            } else {
              // this.$toast({
              //   message: res.message || '系统异常'
              // })
              this.filemesg = res.message;
              this.showtip = true;
            }
          });
          break;
        case "getphoneNumber":
          httper.get("index/tel-phone", requestData, res => {
            if (res.code == 0) {
              that.phoneNumber = res.data;
              sessionStorage.setItem("phoneNumber", that.phoneNumber);
            }
          });
          break;
        // 获取订单信息列表
        case "getStoreList":
          httper.post(
            "store/service-store-list",
            requestData,
            res => {
              that.loads = 1;
              if (res.code == 0 && res.data) {
                let storeList = [];
                // if (this.target > 1) {
                //   storeList = that.storeList;
                // }
                for (let i = 0; i < res.data.length; i++) {
                  storeList.push(res.data[i]);
                }
                that.storeList = storeList;
                // that.storePage++;
                that.storeFlag = res.data.length === that.page_size;
                // if(){

                // }
              }
            },
            false
          );
          break;
        //获取用户车辆送检券
        case "getvehicle":
          httper.get(
            "coupon/vehicle-check",
            requestData,
            res => {
              if (res.code === 0) {
                this.coupon = res.data;
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        case "getService":
          httper.get("product/index-service", requestData, res => {
            if (res.code == 0) {
              that.serviceList = res.data;
              // for (let i = 0; i < 8; i++) {
              //   that.serviceList1.push(res.data[i])
              // }
              // for (let j = 9; j < res.data.length; j++) {
              //   that.serviceList.push(res.data[j])
              // }
              for (let t = 0; t < res.data.length; t++) {
                if (res.data[t].event == "toServiceList") {
                  that.fuwu.push(res.data[t]);
                }
              }
              if (that.fuwu.length > 0) {
                let requestData = {};
                requestData.product_id = that.fuwu[0].product_id;
                requestData.lat = this.latitude;
                requestData.lng = this.longitude;
                requestData.page = this.storePage;
                requestData.page_size = this.page_size;
                this.request("getStoreList", requestData);
              }
            }
          });
          break;
        case "getLocation":
          httper.get("index/ip-location", requestData, res => {
            if (res.code == 0) {
              sessionStorage.setItem("latitude", res.data.location.lat);
              sessionStorage.setItem("longitude", res.data.location.lng);
              sessionStorage.setItem("city", res.data.ad_info.city);
            } else {
              this.$toast({
                message: "定位失败!"
              });
            }
          });
          break;
        //获取用户信息
        case "getUserInfo":
          this.$indicator.open();
          httper.get(
            "wechat/user/info",
            requestData,
            res => {
              this.$indicator.close();
              if (res.code === 0) {
                this.userinfo = res.data;
                // var userId = [42, 45, 46, 49, 50, 168, 167]
                // for (var i = 0; i < userId.length; i++) {
                //   if (userId[i] == this.userinfo.id) {
                //     this.availableUser = true
                //   }
                // }
                if (!(Object.keys(that.userinfo.ccard).length === 0)) {
                  if (that.userinfo.ccard.status == 1) {
                    this.showjihuo = true;
                  }
                }

                // if(localStorage.getItem("usertype")=="2"){
                //   this.usertype = localStorage.getItem("usertype")
                // }else{
                //   if(this.availableUser){
                //     this.showjihuo = true
                //     localStorage.setItem("usertype","1")
                //     this.usertype = localStorage.getItem("usertype")
                //   }else{
                //     localStorage.setItem("usertype","0")
                //   }
                // }
                if (this.userinfo.mobile) {
                  that.phoneNum = this.userinfo.mobile;
                } else {
                  Dialog.confirm({
                    title: "提示",
                    message: "请先绑定手机"
                  })
                    .then(() => {
                      that.$router.push({
                        path: "/changePhoneNum"
                      });
                    })
                    .catch(() => {
                      return false;
                    });
                }
                // sessionStorage.setItem('userinfo', JSON.stringify(userinfo))
                // that.phoneNum = userinfo.mobile ? userinfo.mobile : 'meiyou'
                if (this.userinfo.account) {
                  that.amount = this.userinfo.account.amount;
                }
                if (this.userinfo.can_withdraw == 0) {
                  that.canWithdraw = false;
                }
              } else {
                // this.$swal({
                //     text: res.message || '系统异常',
                // })
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        //获取商品信息
        case "getproductList":
          httper.post(
            "product/mall-product-list",
            requestData,
            res => {
              if (res.code == 0) {
                this.productList = res.data;
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            false
          );
          break;
        //可用时间段
        case "sysconfig":
          httper.get(
            "sys/sys-config",
            requestData,
            res => {
              if (res.code == 0) {
                this.is_stop_mobile_oil = res.data.is_stop_mobile_oil;
                this.stop_mobile_oil_time = res.data.stop_mobile_oil_time;
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            false
          );
          break;
      }
    },
    // getService() {
    //   let that = this
    //   axios.get(process.env.API_HOST + 'product/index-service').then(function(val) {
    //     if (val.data.code == 0) {
    //       that.serviceList = val.data.data
    //     } else {
    //       this.$swal('res.data.message', 'success')
    //     }
    //   })
    // },
    //通过城市名称获取经纬度
    getLal: (address, cb) => {
      var geocoder = new qq.maps.Geocoder();
      geocoder.getLocation(address);
      geocoder.setComplete(function(res) {
        cb(res);
      });
      geocoder.setError(function(err) {
        cb(err);
      });
    },
    getaddress() {
      let that = this;
      let city = this.city;
      that.getLal(city, res => {
        this.latitude = res.detail.location.lat;
        this.longitude = res.detail.location.lng;
        sessionStorage.setItem("latitude", this.latitude);
        sessionStorage.setItem("longitude", this.longitude);
      });
    },

    //获取定位
    getMyLocation() {
      let that = this;
      var geolocation = new qq.maps.Geolocation(
        "444BZ-Z34R4-II6UD-DA3KR-P72IF-46FXB",
        "wechat-map"
      );
      geolocation.getLocation(that.showPosition, that.showErr); //或者用getLocation getIpLocation精确度比较高
    },
    showPosition(position) {
      this.latitude = position.lat;
      this.longitude = position.lng;
      this.city = position.city;
      sessionStorage.setItem("latitude", this.latitude);
      sessionStorage.setItem("longitude", this.longitude);
      sessionStorage.setItem("city", this.city);
    },
    showErr() {
      this.getMyLocation(); //定位失败再请求定位
    }
  }
};
</script>
<style>
/* 轮播图 */
.banner-box {
  width: 100%;
  /* height: 150px; */
  margin-bottom: 20px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  /* line-height: 150px; */
  text-align: center;
  /* background-color: #fbce97; */
  /* margin-bottom: 20px; */
}
.swipeImg {
  width: 100%;
  height: 100%;
}
</style>
<style scoped>
body {
  background-color: #f6f8fa !important;
}
.guaitopbg {
  width: 100%;
  background: linear-gradient(
    0deg,
    #f6f8fa 10%,
    #fbce97 65%,
    #fc9a21 88%,
    #fd8c00 100%
  );
  padding: 20px;
  box-sizing: border-box;
}
.guai-recharge {
  width: 100%;
  margin-bottom: 20px;
  background-image: url("/static/index_rechargebg.png");
  background-size: 100% 100%;
  height: 62px;
  position: relative;
}
.recharge-right {
  position: absolute;
  right: 10px;
  top: 32px;
  display: flex;
  align-items: center;
}
.recharge-box {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.recharge-icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.recharge-num {
  font-size: 12px;
}
.recharge-botton {
  width: 46px;
  height: 23px;
  background: #fd8c00;
  border-radius: 12px;
  font-size: 12px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 菜单 */
.offline-menu-list {
  width: 100%;
  /* display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between; */
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(4, 1fr);
}
.offline-menu-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* margin: 10px 15px; */
}
.offline-menu-icon {
  width: 58px;
  height: 58px;
  border-radius: 19px;
  margin-bottom: 10px;
}
.offline-menu-name {
  font-size: 13px;
}
.mot-img {
  width: calc(100% - 40px);
  margin: 0 20px;
  height: 107px;
  border-radius: 12px;
}
.online-recharge {
  width: calc(100% - 40px);
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.online-rechargeimg {
  width: 173px;
  height: 115px;
  border-radius: 12px;
}
.online-bottom {
  width: calc(100% - 40px);
  margin: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
}
.online-menu {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.online-menu-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
}
.online-menu-icon {
  width: 34px;
  height: 34px;
  margin-bottom: 10px;
}
.online-menu-name {
  font-size: 13px;
}
.recharge-menu {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.recharge-menuimg {
  width: 160px;
  height: 70px;
  border-radius: 12px;
}
.indexnone {
  width: 100%;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/HomeIndex.vue